export default __webpack_public_path__ + "static/LoginPopup-48d7bcd0efd37726a47b12299b61d559.jpg";